// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
import { Component, Input } from "@angular/core";

import { ReportEntry } from "../models/report-entry";

@Component({
  selector: "app-report-list",
  templateUrl: "report-list.component.html",
  standalone: false,
})
export class ReportListComponent {
  @Input() reports: ReportEntry[];
}
